import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    FAILURE_ORGANIZATION_APPOINTMENTS,
    FAILURE_ORGANIZATION_CONTACTS,
    FAILURE_ORGANIZATION_CUSTOMERS,
    FAILURE_ORGANIZATION_CUSTOMER_ADDRESSES,
    FAILURE_ORGANIZATION_CUSTOMER_APPLIANCES,
    FAILURE_ORGANIZATION_CUSTOMER_DATA,
    FAILURE_ORGANIZATION_CUSTOMER_ENABLES,
    FAILURE_ORGANIZATION_CUSTOMER_HISTORY,
    FAILURE_ORGANIZATION_CUSTOMER_LANDINGPAGES,
    FAILURE_ORGANIZATION_CUSTOMER_ORDERS,
    FAILURE_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER,
    FAILURE_ORGANIZATION_CUSTOMER_SUBSCRIPTIONS,
    FAILURE_ORGANIZATION_FAVORITES,
    FAILURE_ORGANIZATION_LEAD_UNLOCK,
    FAILURE_ORGANIZATION_LICENSORS,
    FAILURE_ORGANIZATION_LIST_COUNTS,
    FAILURE_ORGANIZATION_OFFERS,
    FAILURE_ORGANIZATION_OFFICE_PROFIS,
    FAILURE_ORGANIZATION_ORDERS,
    FAILURE_ORGANIZATION_OVERVIEW,
    FAILURE_ORGANIZATION_PLACEMENTS,
    FAILURE_ORGANIZATION_RANKING,
    FAILURE_ORGANIZATION_SIS_PARTNERS,
    FAILURE_ORGANIZATION_STATISTIC,
    FAILURE_ORGANIZATION_TODOS,
    FAILURE_ORGANIZATION_TODO_COUNT,
    FAILURE_REGISTERED_EVENTS,
    FAILURE_VIDEO_LIST,
    REQUEST_ORGANIZATION_APPOINTMENTS,
    REQUEST_ORGANIZATION_CONTACTS,
    REQUEST_ORGANIZATION_CUSTOMERS,
    REQUEST_ORGANIZATION_CUSTOMER_ADDRESSES,
    REQUEST_ORGANIZATION_CUSTOMER_APPLIANCES,
    REQUEST_ORGANIZATION_CUSTOMER_DATA,
    REQUEST_ORGANIZATION_CUSTOMER_ENABLES,
    REQUEST_ORGANIZATION_CUSTOMER_HISTORY,
    REQUEST_ORGANIZATION_CUSTOMER_LANDINGPAGES,
    REQUEST_ORGANIZATION_CUSTOMER_ORDERS,
    REQUEST_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER,
    REQUEST_ORGANIZATION_CUSTOMER_SUBSCRIPTIONS,
    REQUEST_ORGANIZATION_FAVORITES,
    REQUEST_ORGANIZATION_LEAD_UNLOCK,
    REQUEST_ORGANIZATION_LICENSORS,
    REQUEST_ORGANIZATION_LIST_COUNTS,
    REQUEST_ORGANIZATION_OFFERS,
    REQUEST_ORGANIZATION_OFFICE_PROFIS,
    REQUEST_ORGANIZATION_ORDERS,
    REQUEST_ORGANIZATION_OVERVIEW,
    REQUEST_ORGANIZATION_PLACEMENTS,
    REQUEST_ORGANIZATION_RANKING,
    REQUEST_ORGANIZATION_SIS_PARTNERS,
    REQUEST_ORGANIZATION_STATISTIC,
    REQUEST_ORGANIZATION_TODOS,
    REQUEST_ORGANIZATION_TODO_COUNT,
    REQUEST_REGISTERED_EVENTS,
    REQUEST_VIDEO_LIST,
    SUCCESS_ORGANIZATION_APPOINTMENTS,
    SUCCESS_ORGANIZATION_CONTACTS,
    SUCCESS_ORGANIZATION_CUSTOMERS,
    SUCCESS_ORGANIZATION_CUSTOMER_ADDRESSES,
    SUCCESS_ORGANIZATION_CUSTOMER_APPLIANCES,
    SUCCESS_ORGANIZATION_CUSTOMER_DATA,
    SUCCESS_ORGANIZATION_CUSTOMER_ENABLES,
    SUCCESS_ORGANIZATION_CUSTOMER_HISTORY,
    SUCCESS_ORGANIZATION_CUSTOMER_LANDINGPAGES,
    SUCCESS_ORGANIZATION_CUSTOMER_ORDERS,
    SUCCESS_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER,
    SUCCESS_ORGANIZATION_CUSTOMER_SUBSCRIPTIONS,
    SUCCESS_ORGANIZATION_FAVORITES,
    SUCCESS_ORGANIZATION_LEAD_UNLOCK,
    SUCCESS_ORGANIZATION_LICENSORS,
    SUCCESS_ORGANIZATION_LIST_COUNTS,
    SUCCESS_ORGANIZATION_OFFERS,
    SUCCESS_ORGANIZATION_OFFICE_PROFIS,
    SUCCESS_ORGANIZATION_ORDERS,
    SUCCESS_ORGANIZATION_OVERVIEW,
    SUCCESS_ORGANIZATION_PLACEMENTS,
    SUCCESS_ORGANIZATION_RANKING,
    SUCCESS_ORGANIZATION_SIS_PARTNERS,
    SUCCESS_ORGANIZATION_STATISTIC,
    SUCCESS_ORGANIZATION_TODOS,
    SUCCESS_ORGANIZATION_TODO_COUNT,
    SUCCESS_REGISTERED_EVENTS,
    SUCCESS_VIDEO_LIST,
} from './actions';

/* Organization statsitic */
export function organizationStatisticReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_STATISTIC:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_STATISTIC: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_STATISTIC:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization lead-unlock */
export function organizationLeadUnlockReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_LEAD_UNLOCK:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_LEAD_UNLOCK:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORGANIZATION_LEAD_UNLOCK:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization ranking */
export function organizationRankingReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_RANKING:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_RANKING:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORGANIZATION_RANKING:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization appointments */
export function organizationAppointmentsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_APPOINTMENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_APPOINTMENTS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORGANIZATION_APPOINTMENTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organisation-wide orders */
export function organizationOrdersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_ORDERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_ORDERS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORGANIZATION_ORDERS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organisation-scoped offers */
export function organizationOffersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_OFFERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_OFFERS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORGANIZATION_OFFERS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization overview */
export function organizationOverviewReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_OVERVIEW:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_OVERVIEW: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_OVERVIEW:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function organizationContactsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CONTACTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CONTACTS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CONTACTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization to-dos */
export function organizationTodosReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_TODOS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_TODOS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_TODOS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization to-do count */
export function organizationTodoCountReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_TODO_COUNT:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_TODO_COUNT: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_TODO_COUNT:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Organization list-view counts */
export function organizationListCountsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_LIST_COUNTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_LIST_COUNTS:
            return _.assign({}, state, { isFetching: false, content: action.counts, error: undefined });
        case FAILURE_ORGANIZATION_LIST_COUNTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Registered Events */
export function registeredEventsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_REGISTERED_EVENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_REGISTERED_EVENTS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_REGISTERED_EVENTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Appliances */
export function organizationCustomerAppliancesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_APPLIANCES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_APPLIANCES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_APPLIANCES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Video List */
export function videoListReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_VIDEO_LIST:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_LIST: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_LIST:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Orders */
export function organizationCustomerOrdersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_ORDERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_ORDERS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_ORDERS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Subscriptions */
export function organizationCustomerSubscriptionsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_SUBSCRIPTIONS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_SUBSCRIPTIONS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_SUBSCRIPTIONS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Data */
export function organizationCustomerDataReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_DATA:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_DATA: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_DATA:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Addresses */
export function organizationCustomerAddressesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_ADDRESSES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_ADDRESSES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_ADDRESSES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Landingpages */
export function organizationCustomerLandingpagesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_LANDINGPAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_LANDINGPAGES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_LANDINGPAGES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Referral Partner */
export function organizationCustomerReferralPartnerReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer Enables */
export function organizationCustomerEnablesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_ENABLES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_ENABLES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_ENABLES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Favorites */
export function organizationFavoritesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_FAVORITES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_FAVORITES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_FAVORITES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customers */
export function organizationCustomersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMERS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMERS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Sis Partners */
export function organizationSisPartnersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_SIS_PARTNERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_SIS_PARTNERS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_SIS_PARTNERS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Licensors */
export function organizationLicensorsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_LICENSORS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_LICENSORS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_LICENSORS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Placements */
export function organizationPlacementsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_PLACEMENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_PLACEMENTS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_PLACEMENTS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Office Profis */
export function organizationOfficeProfisReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_OFFICE_PROFIS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_OFFICE_PROFIS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_OFFICE_PROFIS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Fetch Organization Customer History */
export function organizationCustomerHistoryReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORGANIZATION_CUSTOMER_HISTORY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORGANIZATION_CUSTOMER_HISTORY: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ORGANIZATION_CUSTOMER_HISTORY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
